<template>
  <div class="nav">
    <v-toolbar color="primary" dark class="fixed-top">
      <div class="ml-4">
        <v-menu
          :offset-y="offset"
          transition="slide-y-transition"
          open-on-hover
          bottom
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <v-app-bar-nav-icon v-on="on" />
          </template>
          <v-list>
            <v-list-item @click="goTo('/')">
              <v-list-item-title>
                <v-icon color="#59065d">mdi-shield-home</v-icon>My B Channel
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="goTo('/topup')">
              <v-list-item-title>
                <v-icon color="#59065d">mdi-flash</v-icon>Quick Pay
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="goTo('/manage')">
              <v-list-item-title>
                <v-icon class="mr-1" style="margin-top:-2px" color="#59065d">mdi-plus-box-outline</v-icon>Current Packs
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="goTo('/manage/add')">
              <v-list-item-title>
                <v-icon class="mr-1" style="margin-top:-3px" color="#59065d">mdi-credit-card-plus</v-icon>Modify Packs
              </v-list-item-title>
            </v-list-item>

            <v-list-group v-model="active" color="primary" active-class="active-item">
              <template v-slot:activator>
                <div>
                  <v-icon class="mr-1" color="#59065d">mdi-help-circle-outline</v-icon>Support
                </div>
              </template>
              <v-list class="submenu">
                <v-list-item @click="goTo('/service-request')">
                  <v-list-item-title style="font-size:14px;">
                    <v-icon class="mr-1" color="#59065d">mdi-clipboard-alert</v-icon>Register Complaints
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="goTo('/faqs')">
                  <v-list-item-title style=" font-size:14px;">
                    <v-icon class="mr-1" color="#59065d">mdi-frequently-asked-questions</v-icon>FAQs
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-list-group>
            <v-list-group v-model="ractive" color="primary" active-class="active-item">
              <template v-slot:activator>
                <div>
                  <v-icon class="mr-1" color="#59065d">mdi-clipboard-outline</v-icon>Reports
                </div>
              </template>
              <v-list class="submenu">
                <v-list-item @click="goTo('/report/activation')">
                  <v-icon color="#59065d" class="mr-1">mdi-database-plus</v-icon> <v-list-item-title>Activation</v-list-item-title>
                </v-list-item>
                <v-list-item @click="goTo('/report/renewal')">
                  <v-icon color="#59065d" class="mr-1">mdi-database-refresh</v-icon><v-list-item-title>Renewal</v-list-item-title>
                </v-list-item>
                <v-list-item @click="goTo('/report/payments')">
                  <v-icon color="#59065d" class="mr-1">mdi-database-check</v-icon><v-list-item-title>Topup</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-list-group>
            <v-list-item @click="goTo('/my-account')">
              <v-list-item-title>
                <v-icon class="mr-1" style="margin-top:-2px" color="#59065d">mdi-account-outline</v-icon>My Profile
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="goTo('/contact-us')">
              <v-list-item-title>
                <v-icon class="mr-1" color="#59065d">mdi-phone-in-talk-outline</v-icon>Contact Us
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="signOut">
              <v-list-item-title>
                <v-icon color="#59065d">mdi-account-lock</v-icon>Sign Out
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-toolbar-title>
        <v-img style="width:90px; cursor: pointer;" @click="goTo('/')" src="/img/Bripl.svg" />
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-toolbar-title>
        <div>
          <span
            style="cursor: pointer; margin-right: 4px;font-size: 15px;"
          >Welcome <b>{{ formatName(userProfile.customer_NAME) }}!</b></span>
        </div>
      </v-toolbar-title>
      <v-btn icon @click="goTo('/my-account')" class="mr-4">
        <v-icon>mdi-shield-account</v-icon>
      </v-btn>
    </v-toolbar>
  </div>
</template>
<script>

import {
  mapState,
  mapGetters
} from "vuex";

export default {
  data: () => ({
    offset: true,
    ractive: false,
    active: false
  }),
  computed: {
    ...mapState("auth", ["userProfile"]),
    ...mapGetters('auth', ['isAdmin'])
  },
  methods: {
    signOut() {
      localStorage.clear();
      this.$router.push({
        name: "Login"
      });
    },
    goTo(path, params) {
      this.$router.push({
        path,
        params
      });
    },
    formatName(name) {
      const nameVal = name.toLowerCase();
      const names = nameVal.split(' ');
      console.log('names : ', names[0].substring(0, 1));
      return names.map(n => n.substring(0, 1).toUpperCase() + n.substring(1)).join(' ')
    }
  }
};
</script>
<style>
.submenu {
  background-color: #eee !important;
}
.active-item {
  color: #111 !important;
}
div {
  font-family: "Nunito", sans-serif;
}
.v-application .primary {
  background-image: linear-gradient(
    225deg,
    #59065d 0%,
    #8d0b93 50%,
    #061d48 100%
  );
}
.fa {
  color: #59065d !important;
}
</style>
